import { render, staticRenderFns } from "./CathayLifeInsurance.vue?vue&type=template&id=6401f189"
import script from "./CathayLifeInsurance.vue?vue&type=script&lang=js"
export * from "./CathayLifeInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports